import { AcceptanceLevel } from '@/api/requests/offers';
import { SystemRole } from '@/api/requests/users';
export const ROLE_ACCEPT_MAP = {
    [AcceptanceLevel.PLACE]: SystemRole.PLACE_MANAGER,
    [AcceptanceLevel.STRUCTURE]: SystemRole.STRUCTURE_MANAGER,
    [AcceptanceLevel.CENTRAL]: SystemRole.BRAND_ADMIN,
};
